import gql from "graphql-tag";

export default gql`
	mutation signUp($signUpInput: SignUpInput!) {
		signUp(signUpInput: $signUpInput) {
			token
			refreshToken
			customer {
				customerID
			}
		}
	}
`;

export const readRegistrationResult = ({ data }) => data?.signUp;

export const packSignUpInput = ({ firstName, lastName, company, email, password }) => ({
	signUpInput: { firstName, lastName, company, email, password, createdBy: "customer sign up" },
});
